import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useParams, Link, useRouteMatch} from 'react-router-dom';
import ExhibitionList from '../Exhibition/exhibition-list';

function UpcomingExhibitonInMuseumDetail(){
    const [exhibitionList, setExhibitionList] = useState();
  

    const [tag, setTag] = useState();
    let {id} = useParams();
    let {url} = useRouteMatch();

    useEffect(()=>{
        getExhibitionList()
        getTag()
    }, [id]);

    const image_in_list = `${process.env.PUBLIC_URL}/project_exhibition.jpg`


    function getTag(){
        let arrayUrl = url.split('/')
        let tagFromUrl = arrayUrl[3];
        setTag(tagFromUrl)
    };

    function getExhibitionList(){
        axios.get(`/api/get_upcoming_exhibition/${id}`)
        .then(exhibitonDataFromMongo=>{
            setExhibitionList(exhibitonDataFromMongo.data)

        })
        .catch(error=>{
            console.log(error)
        })
    }

    return(
        <div className='current_exhibition'>
            <div className='exhibition_map_flex'>
             <div className='current_upcoming_flex'>
                <Link to={`/museums/list/${tag}/detail/${id}`}><p className='current_exhibition_in_upcoming_detail'>Current Exhibitons</p></Link>
                <p className='upcoming_exhibition_in_upcoming_detail'>Upcoming Exhibitons</p>
            </div>
            <Link to={`/museums/list/${tag}/detail/map/${id}`}><p className='map_in_upcoming_detail'>Map</p></Link>
            </div>
            {(exhibitionList)?
            <ul>
            <div>
                {exhibitionList.map((exhibition)=>
                <li key={exhibition._id}>
                    <Link to={`/exhibitions/upcoming/list/all/detail/${exhibition._id}`}>
                    <div className='current_exhibition_wrapper'>
                        <img src={exhibition.image==''? image_in_list:exhibition.image}/>
                    <h3>{exhibition.name}</h3>
                    <p className='copyright_in_current_exhibition'>{exhibition.image_copyright}</p>
                    <p className='data_in_current_exhibition'>{exhibition.modifyOpnday} - {exhibition.modifyClsday}</p>
                    </div>
                </Link>
                </li>
                )}
            </div>
            </ul>
            :''}
            
        </div>
    )

}

export default UpcomingExhibitonInMuseumDetail;